import { useReactiveVar } from "@apollo/client";
import type { DraggedItemType } from "../../../../utils/dragAndDrop";
import { localEditorDraggedItemTypeVar } from "../../State";

export function useDraggedItemType(): DraggedItemType | null {
    return useReactiveVar(localEditorDraggedItemTypeVar);
}
